import { ENABLE_CREDIT_CARD_LIST } from './types';
import { disableBodyScroll } from '../../util';

const enableCreditCardList = () => {
  disableBodyScroll();
  return { type: ENABLE_CREDIT_CARD_LIST };
};

export default enableCreditCardList;



// WEBPACK FOOTER //
// ./src/actions/modals/enableCreditCardList.js